import { render, staticRenderFns } from "./privacy-policy.vue?vue&type=template&id=bc21e2be&"
import script from "./privacy-policy.vue?vue&type=script&lang=ts&"
export * from "./privacy-policy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports